import { render, staticRenderFns } from "./summarize.vue?vue&type=template&id=989cc612&scoped=true"
import script from "./summarize.vue?vue&type=script&lang=js"
export * from "./summarize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989cc612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('989cc612')) {
      api.createRecord('989cc612', component.options)
    } else {
      api.reload('989cc612', component.options)
    }
    module.hot.accept("./summarize.vue?vue&type=template&id=989cc612&scoped=true", function () {
      api.rerender('989cc612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/summarize.vue"
export default component.exports